import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=52a09e6e&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=ts&"
export * from "./editor.vue?vue&type=script&lang=ts&"
import style0 from "./editor.vue?vue&type=style&index=0&id=52a09e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a09e6e",
  null
  
)

export default component.exports